import React from 'react';
import {useParams} from "react-router-dom";
import DailyGame from '../DailyGame/DailyGame.tsx';
import { GameType } from '../../types/GameType.ts';

type ArchivedGameProps = {
  gameType: GameType;
};

export default function ArchivedGame({ gameType }: ArchivedGameProps) {
  const {gameNumber} = useParams();
  // param is of type string, must convert to number
  const gameNumberNumber = Number(gameNumber);
  
  return (
    <DailyGame 
      gameNumber={gameNumberNumber} 
      isArchive={true} 
      gameType={gameType} 
    />
  );
}